/**
  * 判断是否为空对象
  *
  * @param {Object} obj 对象
  * @return {Boolean}
  */
function isEmpty (obj) {
  for (var key in obj) {
    return false
  }
  return true
}

module.exports = isEmpty



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/isEmpty.js
// module id = p730
// module chunks = 137